export const environment = {
  production: true,
  useJson: true,
  jsonBaseUrl: 'https://cf-media.addtix.id/',
  apiBaseUrl: 'https://battle-plane.addtix.id/',
  assetBaseUrl: 'https://cf-media.addtix.id/',
  // xendit_public_key: 'xnd_public_development_dOPYH6NYUwgOJY1sg3JoMTV1Ag7wOb1LX3OyjUrwZxt0HF1Q7juX1py4Tcd1M9id',
  xendit_public_key: 'xnd_public_production_nny_CO95aRC8tVta0RStvOMXY3z5wjetNG0cUONjtKdEO0gw0Pt0uMPKRD1cF4J',
  bankTransferAccountNo:'5435-788-855',
  bankTransferAccountName:'PT Reservasi Multi Teknologi',
  bniLifeUrl: 'https://lifestyle.bni.co.id',
  bniLifeVaMin:21,
  bniLifeVaCount:29,
  bniLifeVaStaticPrefix:'98835353010100',
  firebase: {
    apiKey: "AIzaSyDcaWNhWuzWKckMPc2Fj8G3zeqr3Ju9wF8",
    authDomain: "cognitix-fd040.firebaseapp.com",
    projectId: "cognitix-fd040",
    storageBucket: "cognitix-fd040.appspot.com",
    messagingSenderId: "71263280967",
    appId: "1:71263280967:web:41fb3040f55b7a3a9db662",
    measurementId: "G-6WPGYHFR7S"
  },
  recaptcha: {
    siteKey: '6Ldg14gqAAAAAOZMrmSBDcPSUCij-nNwxc3B_K_G',
  },
  fingerprint:{
    apiKey: 'OLJjYeruo2RP4iZzP3AY',
    region: "ap"
  },
  sentry: {
    dsn: 'https://6a6a41bde47e86bf0a06feb54ace7681@o4508758216605696.ingest.us.sentry.io/4508759734681600'
  },
  akId: 510,
  redirect: {
    510: 'https://www.aaronkwokinjkt.com/',
    547: 'https://www.overpassinjakarta2025.com/',
    554: 'https://www.richierenindonesia.com/',
    612: 'https://reg.iiccsforum.com/',
    669: 'https://www.bithelastparadeinjakarta.com/',
    1018: 'https://alamatelier.addtix.id/',
    1028: 'https://alamatelier.addtix.id/',
  },
  clId: 491,
  klbbBRIId: 545,
  kahitnaId: 556,
  esId: 559,
  miId: 560,
  pixelsData: [
    {
      eventId: 559,
      tagId: '602058486125181',
    },
    {
      eventId: 560,
      tagId: '602058486125181',
    },
    {
      eventId: 597,
      tagId: '664352389287247',
    },
    {
      eventId: 599,
      tagId: '664352389287247',
    },
    {
      eventId: 600,
      tagId: '664352389287247',
    },
    {
      eventId: 606,
      tagId: '664352389287247',
    },
    {
      eventId: 594,
      tagId: '1836268923835848',
    },
    {
      eventId: 799,
      tagId: '1734574133894082',
    },
    {
      eventId: 508,
      tagId: '1157413122934268',
    },
    {
      eventId: 844,
      tagId: '1734574133894082',
    },
    {
      eventId: 1005,
      tagId: '794504289764272',
    },
    {
      eventId: 1021,
      tagId: '1433424588451050',
    },
    {
      eventId: 1048,
      tagId: '2573640849759665',
    },
    {
      eventId: 1063,
      tagId: '2573640849759665',
    },
    {
      eventId: 1066,
      tagId: '2573640849759665',
    },
    {
      eventId: 1047,
      tagId: '29143347901939735',
    },
    // Jumbo runs two Meta pixels: rows 1 and 11 of the marketing sheet list Headliners and ADS
    // both as "Used for: Addtix / Implement On Access Page" — two ad accounts, same pages.
    // Two entries for one eventId is what triggers the multi-pixel path in GtagService; every
    // other event has a single entry and keeps the original single-pixel code path.
    {
      eventId: 1053,
      tagId: '2206873003192600',   // Meta Ads - Headliners
    },
    {
      eventId: 1053,
      tagId: '1428331425819835',   // Meta Ads - ADS
    },
  ],
  tiktokPixels: [
    {
      eventId: 1053,
      pixelId: 'D9SOK3BC77U6RO6J5VH0',
    },
  ],
  // Per-event SEO overrides. MUST mirror EVENT_OVERRIDES in functions/event/[slug].js — the
  // Pages Function injects these server-side and this component rewrites them after boot, so
  // if the two disagree the client silently wins and the server work is invisible to Google.
  seoOverrides: [
    {
      eventId: 1053,
      venueFirst: true,                                 // title uses venue_name over province_name
      canonical: 'https://jumboadventurun.addtix.id/',  // vanity domain, not the API's subdomain
    },
  ],
  googleAds: [
    {
      eventId: 1053,
      awId: 'AW-18361606137',
      labels: {
        access: '8yPFCN--uN0cEPm_v7NE',
        booking: 'MiShCLrwqN0cEPm_v7NE',
        information: 'yItjCJqSqd0cEPm_v7NE',
        payment: 'y4-GCND4ud0cEPm_v7NE',
        purchase: 'zRApCJTB7NwcEPm_v7NE',
      },
      // Column E of the marketing sheet. Ops sees only "Conversion" without these and cannot
      // tell which step a conversion came from. Attribution stays keyed on the send_to label,
      // so naming the event changes reporting only. Omit for an event to keep plain 'conversion'.
      eventNames: {
        access: 'Access Page (Page View)',
        booking: 'Booking Page',
        information: 'Information Page',
        payment: 'Payment Page',
        purchase: 'Purchase Payment Jumbo',
      },
    },
  ],
  gtmData: [
    {
      eventId: 660,
      tagId: 'GTM-NT7DRX29',
    },
    {
      eventId: 785,
      tagId: 'GTM-W5TRWSHQ',
    },
    {
      eventId: 1050,
      tagId: 'GTM-NM8SHB5Z',
    },
    {
      eventId: 1063,
      tagId: 'GTM-NM8SHB5Z',
    },
    {
      eventId: 1070,
      tagId: 'GTM-NM8SHB5Z',
    }
  ],
  amLounge:{
    tagId: '1112597976803774',
    events: [550,549,548,607]
  },
  eventIdBca: 508,
  eventIdOcbc: 552,
  dewa19CFUrl: 'https://redemption-jersey-dewa19.addtix.id/',
  dewa19Slug: 'pengambilan-jersey-dewa-19',
  dewa19id: 659,
  dewa19rdr: 'https://www.dewa19allstars.com/',
  bsrId:660,
  biId:669,
  biIdList: [669,861],
  JDIOId: 989,
  JDIOIDId: 997,
  rawDanceId: 1007,
  whiteLabel: [
    {
      slug: 'indonesia-derby-2025',
      logo: 'sarga-logo.png',
      type: 'basic',
    },
    {
      slug: 'sarga-festival-2025',
      logo: 'sarga-logo.png',
      type: 'basic',
    },
    {
      slug: 'affiliate-festival-sarga',
      logo: 'sarga-logo.png',
      type: 'basic',
    },
    {
      slug: 'ihr',
      logo: 'sarga-logo.png',
      type: 'basic',
    },
    // ponytail: must stay above 'sarga' — getWhiteLabel returns the first slug the path includes
    {
      slug: 'sarga-fest-2026-jakarta',
      logo: 'cowboy-festival-logo.png',
      type: 'basic',
    },
    {
      slug: 'sarga-fest-a5wfjy',
      logo: 'cowboy-festival-logo.png',
      type: 'basic',
    },
    {
      slug: 'sarga',
      logo: 'sarga-logo.png',
      type: 'basic',
    },
    {
      slug: 'hamengku-buwono-x-cup-2026',
      logo: 'sarga-logo.png',
      type: 'basic',
    },
    {
      slug: 'm7',
      logo: 'm7-logo.png',
      type: 'advance',
      promoter: 'Moonton',
      phone: '+62821-2599-9908',
      wa: '6282125999908',
      email: 'info@addtix.id',
      address: 'Jakarta',
    },
    {
      slug: 'im3',
      logo: 'IM3-logo.png',
      type: 'advance',
      promoter: 'IM3',
      phone: '+62858‑9451‑1819',
      wa: '6285894511819',
      email: 'info@addtix.id',
      address: 'Jakarta',
    },
  ],
  mustSource: [{
    id: 847,
    source:'mypertamina'
  },{
    id: 1032,
    source:'mandiri_sukha'
  }],
  showtimeLabels: {
    841: {'00:00': 'IHR', '15:00': 'Sarga Festival'},
    1065: {'18:00': 'IHR', '15:00': 'Sarga Festival', '20:00': 'Sarga Festival'}
  },
  hideBackEventUrl:[1021,1027],
  sortCategoriesByPriceEventIds:[1021],
  sukhaTnc: [
    {
      uri: 'brian-mcknight-v9k2mrxq',
      url: 'https://bmri.id/KonserBrianMcKnight',
    },
  ],
  seatingMapAtelier: [
    {
      id: [2175,2277],
      key: 'regular-1st-floor',
    },
    {
      id: [2174,2276],
      key: 'vip-1st-floor',
    },
    {
      id: [2256,2279],
      key: 'regular-2nd-floor-left',
    },
    {
      id: [2257,2280],
      key: 'regular-2nd-floor-center',
    },
    {
      id: [2258,2281],
      key: 'regular-2nd-floor-right',
    },
    {
      id: [2255,2278],
      key: 'vip-2nd-floor',
    },
  ]
};
